export type AppLocale = "cs" | "pl"
export const DEFAULT_LOCALE = "cs"

// export const getLocaleDescription = (t: TFunction<"common">): Record<AppLocale, string> => {
//     return {
//         cs: t("labels.czech"),
//         en: t("labels.english"),
//     }
// }

export const appLocaleToSystemLocale = (appLocale: AppLocale) => {
    switch (appLocale) {
        case "cs":
            return "cs-CZ"
        case "pl":
            return "pl-PL"
    }
}

export const localeNumericSeparatos: Record<AppLocale, { thousand: string; decimal: string }> = {
    cs: {
        thousand: " ",
        decimal: ",",
    },
    pl: {
        thousand: ".",
        decimal: ",",
    },
}
